import { render, staticRenderFns } from "./warehouseControl.vue?vue&type=template&id=22d9548a&scoped=true"
import script from "./warehouseControl.vue?vue&type=script&lang=js"
export * from "./warehouseControl.vue?vue&type=script&lang=js"
import style0 from "./warehouseControl.vue?vue&type=style&index=0&id=22d9548a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9548a",
  null
  
)

export default component.exports